import React from 'react';

import { translate } from 'helpers/Translate';
import Bathtub from 'svg/Bathtub';
import Door from 'svg/Door';

/**
 * Tips of the main informations about the property
 */
const Tips = () => (
    <div>
        <div className="tip padding-bottom-double">
            <h3 className="tip__title">
                <Door className="tip__icon" />
                {translate('Nombre de pièces')}
            </h3>
            <p className="tip__text">
                {translate(
                    'Salle de bains, dressing, débarras et cuisine sont à exclure du nombre de pièces.',
                )}
            </p>
        </div>
        <div className="tip">
            <h3 className="tip__title">
                <Bathtub className="tip__icon" />
                {translate('Nombre de salles de bains')}
            </h3>
            <p className="tip__text">
                {translate("Salle d'eau avec une baignoire ou une douche.")}
            </p>
        </div>
    </div>
);

Tips.displayName = 'Tips';

/**
 * Tips Functionnal Component
 */
export default Tips;
